angular.module('bmsApp.audit', [])
	.config(function config($stateProvider) {

			$stateProvider

				.state('main.auditLog', {
					url: '^/audit-log',
					views: {
						'main@main': {
							templateUrl: 'ng/global/audit/templates/AuditLog.html',
							controller: 'AuditLogCtrl'
						}
					},
					ncyBreadcrumb: {label: 'Audit Log'}
				})

			;

		});
